import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import * as crud from "./operations";
import { ClientEditModal, ClienDeleteModal } from "./editModal";
import { ActionsColumnFormatter } from "./buttonsActions";
import * as _enter from "../CatalogClients/operations"


import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import axios from "axios"
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { filterFactory, optionsFactory, FilterLayout } from "../../helper/table"
import ExcelExport from "../../helper/export-xlsx"
import PDFExport from "../../helper/export-pdf"
import { useToasts } from 'react-toast-notifications';
import { useSelector } from "react-redux";

const { ExportCSVButton } = CSVExport;
function Wrapper(props) {
  const { addToast } = useToasts()
  const { user } = useSelector(state => state.auth);
  const userDocument = user.uid ? user : user.payload

  const [queryng, setQuery] = useState(true)
  const [documents, setDocuments] = useState([]);
  const [edit_show, setEditShow] = useState(false);
  const [delete_show, setDeleteShow] = useState(false);

  const [filter, setFilter] = useState("");
  const [enter, setEnter] = useState({})
  const [activeClient, setActiveClient] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      const [
        users_query,
        enter_query
      ] = await Promise.all([
        crud.getClient(""),
        _enter.getClient(userDocument.company_id)
      ])

      const employees = users_query.data.payload
      const enter = enter_query.data.payload

      setDocuments(employees)
      setEnter(enter)
      setQuery(false);

    }
    fetchData()
  }, [userDocument.company_id]);
  const controllers = {
    controllers: props.controllers,
    show: edit_show,
    delete: delete_show,
    client: activeClient,
    handleClose: () => setEditShow(false),
    handleShow: () => setEditShow(true),
    hideDelete: () => setDeleteShow(!delete_show),

    handleDelete: (uid) => {
      crud
        .getClient(uid)
        .then((res) => {
          const client = res.data.payload;
          setActiveClient(client);
          setDeleteShow(true);
        })
        .catch(function (thrown) {
          if (axios.isCancel(thrown)) {
            console.log(`request cancelled:${thrown.message}`)
          } else {
            console.log('another error happened')
          }
        })
    },
    deleteClient: (uid) => {
      crud.deleteClient(uid).then(() => {
        crud.getClients(setDocuments);
        addToast(process.env["REACT_APP_DELETE"], { appearance: 'success' });


        setDeleteShow(!delete_show);
      }).catch(err => {
        addToast(process.env["REACT_APP_NO_DELETE"], { appearance: 'error' });
      })
    },
    update: (client) => {
      crud.updateClient(client).then(() => {
        crud.getClients(setDocuments);
        addToast(process.env[`REACT_APP_${(client.uid ? "update" : "create").toUpperCase()}`], { appearance: 'success' });

        setEditShow(!edit_show);
      }).catch(err => {
        addToast(process.env[`REACT_APP_${(client.uid ? "no_update" : "no_create").toUpperCase()}`], { appearance: 'error' });


      })
    },
    openEdit: (uid) => {
      if (uid) {
        crud
          .getClient(uid)
          .then((res) => {
            const client = res.data.payload;
            setActiveClient(client);
            setEditShow(!edit_show);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setActiveClient({});
        setEditShow(!edit_show);
      }
    },
  };

  if (!crud.columns.filter((col) => col.dataField === "action").length) {
    crud.columns.push({
      dataField: "action",
      text: "Actions",
      formatter: ActionsColumnFormatter,
      formatExtraData: controllers,
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    });
  }
  const fields = ["name", "last_name", "email", "email", "phone"]
  const users = documents.filter(user => user.company_id === userDocument.company_id)
  const data = filterFactory(users, filter, fields)
  const options = optionsFactory(data)
  return (
    <ToolkitProvider
      keyField="uid"
      data={data.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
      columns={crud.columns}
      exportCSV={true}
    >
      {
        toolkit => (
          <>      <div
            className="content d-flex flex-column flex-column-fluid"
            id="kt_content"
          >
            <div className="card card-custom gutter-b">
              <div className="card-header d-flex justify-content-between">
                <h5 className="mt-7 card-label">Employees List</h5>

                <div className="card-toolbar">
                  <div className="card mx-2">
                    <div className="card-toolbar">
                      <span className="svg-icon svg-icon-md  mx-2">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
                        />
                      </span>
                      <ExportCSVButton
                        {...toolkit.csvProps}
                        className="btn btn-info font-weight-bolder mx-1"
                      >
                        .CSV
                    </ExportCSVButton>
                      <PDFExport columns={fields} data={data} name="employees">
                        <button className="btn btn-danger font-weight-bolder mx-1">
                          .PDF
                          </button>
                      </PDFExport>
                      <ExcelExport columns={fields} data={data} name="employees">
                        <div className="btn btn-success font-weight-bolder mx-2">
                          .XLS
                          </div>
                      </ExcelExport>
                    </div>
                  </div>
                  <div className="col text-center">
                    <br />

                    <button
                      disabled={((enter.limit ?? 10) - users.length) <= 0 || queryng}
                      className="btn btn-primary font-weight-bolder new-employees-ref"
                      onClick={() => {
                        controllers.openEdit();
                      }}
                    >
                      <span className="svg-icon svg-icon-md">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Design/Flatten.svg")}
                        />
                      </span>New Employee</button>
                    <br />
                    <small className="text-muted">Available: <b>{!queryng ? (enter.limit ?? 10) - users.length : 0}</b></small>

                  </div>
                </div>

              </div>

              <div className="card-body">
                <FilterLayout controller={setFilter} />
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  bordered={false}
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="uid"
                  {...toolkit.baseProps}
                  loading={queryng}
                  pagination={paginationFactory(options)}
                  overlay={overlayFactory({ spinner: true })}
                  noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                ></BootstrapTable>

              </div>
            </div>
          </div>
            <ClientEditModal {...controllers} />
            <ClienDeleteModal {...controllers} />
          </>
        )
      }
    </ToolkitProvider >
  );
}
export default injectIntl(connect(null, auth.actions)(Wrapper));